import moment from 'moment';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { IPressItemDataProps } from '@/types/Press';
import styles from './Card.module.scss';
import classNames from 'classnames';

interface ICardProps {
  item: {
    description: string;
    id: number | string;
    image: { url: string };
    title: string;
    release: string | number;
  };
}
const BlogCard = (props: ICardProps) => {
  const { item } = props;

  const router = useRouter();

  const handleChangeRoute = () => {
    router.push(`/blogs/${item.id}`);
  };

  // Ensure the logo URL is valid and correctly formatted
  const imageUrl = item?.image?.url ? item?.image?.url : '/images/default-image.png'; // Fallback image if no URL

  return (
    <>
      <div className={styles.wrapper} onClick={handleChangeRoute}>
        <div className={styles.inner}>
          <div className={styles.image}>{item?.image?.url && <Image src={imageUrl} layout='fill' alt='image' objectFit='cover' />}</div>
          <div className={styles.info}>
            <div className={styles.date}>{moment.utc(item?.release)?.format('DD/MM/YYYY')}</div>
            {/* <div className={styles.divider} /> */}
            {/* <div className='w-full h-[19px] relative flex'>
              <Image src={logoUrl} alt='image' layout='fill' objectFit='contain' objectPosition={'left'} />
            </div> */}
          </div>
          <div className={styles.text}>
            <div className={styles.boxText}>{item?.title}</div>
          </div>
          <div className={styles.buttonContainer}>
            {/* {item?.link_name && ![null, undefined, 'nil', 'non', '', 'null', 'undefined', 'none'].includes(item?.link_name) ? ( */}
            <div className={classNames(styles.source, 'button-hover-effect')}>
              <p>Show More</p>
            </div>
            {/* ) : (
              <div className={styles.source}>
                <p>{item?.link_name}</p>
              </div>
            )}*/}
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogCard;
